import { render, staticRenderFns } from "./UploadThreshold.vue?vue&type=template&id=ec22bce8"
import script from "./UploadThreshold.vue?vue&type=script&lang=js"
export * from "./UploadThreshold.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports